/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CreateAction({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Treatment/Empty/NewTreatmentModal/Content/CreateAction",
  onSubmit,
  isSubmitting
  
}) {
let createTreatmentSubmitData = fromData.useDataSubmit({ viewPath,
context: 'create_treatment',
})
let createTreatmentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'create_treatment',
})
let createTreatmentSubmitData1 = fromData.useDataSubmit({ viewPath,
context: 'create_treatment',
})
let createTreatmentIsSubmittingData1 = fromData.useDataIsSubmitting({ viewPath,
context: 'create_treatment',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="create_treatment"
 onClick={createTreatmentSubmitData}
 disabled={createTreatmentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create"
/>
<Shortcut
{...childProps}
  viewPath={`${viewPath}/Shortcut`}
 keys="enter"
 data="create_treatment"
 onClick={createTreatmentSubmitData1}
 disabled={createTreatmentIsSubmittingData1}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}